export default __webpack_public_path__ + "static/media/pdv-logo-white.3ad975a2.svg";